import * as PIXI from "pixi.js";
import { Spine } from "@pixi/spine-pixi";
import gsap from "gsap";

export class BonusIntro extends PIXI.Container {
    private skeleton: Spine;
    private content: PIXI.Container;
    private fsText: PIXI.Text;
    private tapText: PIXI.Text;

    private bonusStartEvent: CustomEvent = new CustomEvent("BONUS_START");

    constructor() {
        super();
        this.skeleton = Spine.from({
            skeleton: "curtainsJson",
            atlas: "curtainsAtlas",
        });
        this.skeleton.scale.set(0.2);
        this.skeleton.state.addListener({
            complete: (entry) => {
                if (entry.animation) {
                    this.emit(entry.animation.name);
                }
            },
        });
        this.addChild(this.skeleton);

        this.content = new PIXI.Container();
        this.addChild(this.content);

        this.fsText = new PIXI.Text({
            text: "Congratulations\nYou won 5 Free Spins!",
            style: {
                fontSize: 50,
                align: "center",
                fontFamily: "TextFont",
                fill: "0xfad035",
                stroke: { color: "0x4a1850", width: 4, join: "round" },
            },
        });
        this.fsText.anchor.set(0.5);
        this.fsText.position.set(0, -130);
        this.content.addChild(this.fsText);

        this.tapText = new PIXI.Text({
            text: "Tap Anywhere to Continue",
            style: {
                fontSize: 35,
                align: "center",
                fontFamily: "TextFont",
                fill: "0xffffff",
                stroke: { color: "0x000000", width: 4, join: "round" },
            },
        });
        this.tapText.anchor.set(0.5);
        this.tapText.position.set(0, 100);
        this.content.addChild(this.tapText);

        this.visible = false;
    }

    async show() {
        return new Promise<void>((resolve) => {
            this.visible = true;
            this.skeleton.state.setAnimation(0, "show", false);
            this.skeleton.state.addAnimation(0, "idle", true);

            this.content.alpha = 0;
            this.content.visible = true;
            gsap.to(this.content, {
                delay: 1,
                duration: 1,
                alpha: 1,
                onComplete: () => {
                    resolve();
                },
            });
        });
    }

    async hide() {
        return new Promise<void>((resolve) => {
            this.content.visible = false;
            this.skeleton.state.setAnimation(0, "hide", false);
            this.once("hide", () => {
                this.visible = false;
                document.dispatchEvent(this.bonusStartEvent);
                resolve();
            });
        });
    }
}
